import { Duration, milliseconds } from 'date-fns'
import { useTranslation } from 'react-i18next'
import AlertContainer from './AlertContainer'

const GoToGarageAlert = ({ timeToDropoff }: { timeToDropoff: Duration }) => {
  const { t } = useTranslation('navigation')
  const showDropoff = milliseconds(timeToDropoff) === 0

  if (!showDropoff) {
    return null
  }

  return (
    <AlertContainer
      type="alert"
      alertColor="teal"
      alertText={t('goToDropoff')}
      position="bottom"
      opacity="low"
      noOverlay
      height="tiny"
    />
  )
}

export default GoToGarageAlert
